(function() {
    'use strict';

    angular.module("imApp").factory("stockReplenishmentOverviewService", [function() {
        let service = {};

        return service;
    }]);
})();
